export default {
    site: {
        language: 'pl',
        url: 'https://loando.pl',
        name: 'LoanDO',
        legalName: 'LoanDO Sp. z o.o.',
    },

    seo: {
        gtmId: 'GTM-5J4S8V',

        robots: ['/wniosek/', '*?amount', '*?period', '*?url', '/media/'],

        hreflang: [
            { url: 'https://loando.pl/', lang: 'pl' },
            { url: 'https://loando.ro/', lang: 'ro' },
            { url: 'https://loando.cz/', lang: 'cs' },
            { url: 'https://loando.mx/', lang: 'es-mx' },
            { url: 'https://loando.ua/', lang: 'uk' },
            { url: 'https://loando.ua/ru/', lang: 'ru-ua' },
        ],

        schema: {
            aboutUs: {
                name: 'O projekcie LoanDO',
                description:
                    'LoanDO to największy w Polsce broker pożyczkowy, specjalizujący się w łączeniu klientów z setkami sprawdzonych ofert finansowych. Nasz serwis umożliwia szybkie i bezpieczne porównanie oraz dopasowanie pożyczki do indywidualnych potrzeb użytkownika.',
            },

            loanOrCredit: {
                dayType: 'Pożyczka krótkoterminowa',
                monthType: 'Pożyczka długoterminowa',
                bankType: 'Kredyt gotówkowy',
                priceCurrency: 'PLN',
                categoryProduct: 'Ranking ofert i kalkulator pożyczek',
            },

            home: {
                description:
                    'LoanDO to wiodący polski broker i niezależna porównywarka finansowa, dostarczająca rzetelne zestawienia sprawdzonych ofert pożyczkowych. Naszą misją jest zapewnienie transparentności na rynku finansowym i pomoc konsumentom w podejmowaniu bezpiecznych decyzji kredytowych w oparciu o aktualne dane i najwyższe standardy ochrony prywatności.',

                awards: [
                    'Technologiczne Rozwiązanie Roku 2023 według Loan Magazine',
                    'Partner Sprzedaży Roku 2023 według Loan Magazine',
                    'Partner Sprzedaży Roku 2024 według Loan Magazine',
                ],

                knowsAbout: [
                    'https://pl.wikipedia.org/wiki/Finanse_osobiste',
                    'https://pl.wikipedia.org/wiki/Po%C5%9Brednik_kredytowy',
                    'https://pl.wikipedia.org/wiki/Kredyt_konsumencki',
                    'https://pl.wikipedia.org/wiki/Por%C3%B3wnywarka_cen',
                    'https://pl.wikipedia.org/wiki/Zdolno%C5%9B%C4%87_kredytowa',
                ],

                memberOf: {
                    '@type': 'Organization',
                    name: 'Związek Przedsiębiorstw Finansowych w Polsce',
                    sameAs: 'https://zpf.pl/',
                },

                additionalProperty: (firmsCount: number): { [key: string]: string | number }[] => [
                    {
                        '@type': 'PropertyValue',
                        name: 'Opłata za pośrednictwo',
                        value: 0,
                        unitText: 'PLN',
                        description: 'Korzystanie z portalu LoanDO jest całkowicie bezpłatne dla klienta',
                    },
                    {
                        '@type': 'PropertyValue',
                        name: 'Liczba partnerów finansowych',
                        value: firmsCount,
                    },
                ],

                sameAs: ['https://rejestr.io/krs/548045/loando', 'https://zpf.pl/members/loando-sp-z-o-o/'],
            },
        },
    },

    navigation: {
        header: [
            { name: 'Pożyczki krótkoterminowe', url: '/pozyczki-krotkoterminowe/' },
            { name: 'Pożyczki długoterminowe', url: '/pozyczki-dlugoterminowe/' },
            { name: 'Pożyczki bankowe', url: '/pozyczki-bankowe/' },
        ],

        home: [
            { name: 'Pożyczki krótkoterminowe', url: '/pozyczki-krotkoterminowe/', icon: '/assets/firms/slice.svg' },
            { name: 'Pożyczki długoterminowe', url: '/pozyczki-dlugoterminowe/', icon: '/assets/firms/fast-money.svg' },
            { name: 'Pożyczki bankowe', url: '/pozyczki-bankowe/', icon: '/assets/firms/wallet.svg' },
        ],

        footer: [
            { name: 'Partnerzy LoanDO', url: '/partnerzy/' },
            { name: 'Polityka prywatności', url: '/polityka-prywatnosci/' },
            { name: 'Regulamin Portalu LoanDO', url: '/regulamin/' },
        ],

        contact: { name: 'Skontaktuj się z nami', url: '/kontakt/' },
        project: { name: 'O projekcie LoanDO', url: '/projekt-loando/' },

        socialMedia: [
            { name: 'Facebook', href: 'https://www.facebook.com/loandopl' },
            { name: 'LinkedIn', href: 'https://linkedin.com/company/loando-group' },
        ],
    },

    logo: {
        reviews: 'Zaufały nam tysiące osób',

        security: {
            description: 'Twoje dane są chronione',
            gdpr: 'Ochrona danych osobowych zgodna z wymogami RODO',
            ssl: 'Bezpieczne połączenie szyfrowane certyfikatem SSL',
            shield: 'Stały monitoring bezpieczeństwa systemów LoanDO',
        },
    },

    tableOfContents: {
        title: 'Spis treści',
        visible: 'Ukryj spis treści',
        hidden: 'Pokaż spis treści',
    },

    application: {
        short: 'Wnioskuj',
        loan: 'Weź pożyczkę',
        unavailable: 'Dopasuj inne oferty',
    },

    calculator: {
        dayCategory: '/pozyczki-krotkoterminowe/',
        bankCategory: '/pozyczki-bankowe/',

        title: 'Sprawdź wysokość raty i weź pożyczkę!',
        free: 'Wnioskowanie jest bezpłatne!',

        amount: {
            title: 'Ile potrzebujesz?',
            unit: 'zł',
            step: 100,
            bigStep: 500,
            round: 100,
        },

        time: {
            title: 'Kiedy możesz spłacić?',
            dayUnit: 'dni',
            monthUnit: 'mies',
        },

        legal: (
            amountMin: string,
            amount: string,
            amountMax: string,
            timeMin: string,
            time: string,
            timeMax: string,
            aprc: string,
            installment: string,
            cost: string,
            total: string,
        ): string => `
            Reprezentatywny przykład pożyczki: Pożyczana kwota <b>${amount}</b>; Okres pożyczki <b>${time}</b>; 
            Koszt pożyczki <b>${cost}</b>; RRSO <b>${aprc}</b>; Całkowita kwota do spłaty <b>${total}</b>; Wysokość raty <b>${installment}</b>; 
            Minimalna kwota pożyczki <b>${amountMin}</b>; Maksymalna kwota pożyczki <b>${amountMax}</b>;
            Minimalny okres spłaty <b>${timeMin}</b>; Maksymalny okres spłaty <b>${timeMax}</b>.
        `,
    },

    firm: {
        metaTitle: (name: string): string => `${name} - opinie, warunki i informacje o partnerze`,
        metaDescription: {
            cost: (name: string, amountMin: string, amountMax: string, periodMax: string): string =>
                `Oferta ${name}: kwota od ${amountMin} do ${amountMax} na okres do ${periodMax}. Sprawdź aktualne RRSO, koszty i opinie. Szybka decyzja i wniosek 100% online.`,

            default: (name: string): string =>
                `Szczegóły oferty ${name}. Nasz ekspert prześwietla warunki: sprawdź recenzję, ukryte koszty oraz mocne strony pożyczki. Czy warto? Zobacz analizę.`,
        },

        lead: (name: string): string => `Szczegóły oferty ${name}`,
        faq: (name: string): string => `Pytania i odpowiedzi o ${name}`,
        similar: (name: string): string => `Alternatywy dla ${name}`,
        check: (name: string): string => `Sprawdź ${name}`,
        likes: 'wybrało tę ofertę',
        unavailable: 'Oferta nieaktualna',
        modified: 'Ostatnia aktualizacja',

        info: {
            title: (name: string): string => `Dane kontaktowe ${name}`,
            name: 'Nazwa firmy',
            address: 'Adres',
            phone: 'Telefon',
            email: 'E-mail',
            workhours: 'Godziny otwarcia',
        },

        advAndDis: {
            title: (name: string): string => `Zalety i wady ${name}`,
            advantage: 'Zalety',
            disadvantage: 'Wady',
        },

        expert: {
            title: (name: string): string => `Opinia eksperta o ${name}`,
            rating: 'Moja ocena',
        },

        fields: {
            amount: 'Kwota',
            time: 'Okres',
            aprc: 'RRSO',
            installment: 'Wysokość raty',
            cost: 'Koszt pożyczki',
            totalRepayment: 'Kwota do spłaty',
        },

        ranking: {
            full: {
                seeAll: 'Sprawdź nasz ranking',
            },
        },
    },

    article: {
        lead: 'Najważniejsze informacje',
        faq: 'Najczęściej zadawane pytania',
        expert: 'Podsumowanie eksperta',
    },

    contact: {
        title: 'Skontaktuj się z nami',
        metaDescription:
            'Masz pytania o pożyczki? Skontaktuj się z Biurem Obsługi Klienta LoanDO. Jesteśmy do Twojej dyspozycji od pon. do sob. Zadzwoń, napisz e-mail lub użyj formularza!',

        dataTitle: 'Dane kontaktowe',
        phone: '+48611100413',
        email: 'kontakt@loando.pl',

        tax: {
            title: 'Dane firmy',

            main: {
                name: 'NIP',
                value: '9492200470',
            },

            others: [
                { name: 'KRS', value: '0000548045' },
                { name: 'REGON', value: '361006900' },
            ],
        },

        address: {
            title: 'Adres',
            street: 'ul. Marka Kotańskiego 8/3',
            postalCode: '10-166',
            city: 'Olsztyn',
            region: '',
            country: 'PL',
        },

        workhours: {
            title: 'Godziny pracy',
            list: ['Poniedziałek - Piątek: 08:30 - 20:00', 'Sobota: 10:00 - 18:00'],
        },

        form: {
            title: 'Napisz do nas',

            name: {
                label: 'Imię',
                placeholder: 'Podaj swoje imię',
            },

            email: {
                label: 'Adres e-mail',
                placeholder: 'Podaj swój adres e-mail',
            },

            message: {
                label: 'Wiadomość',
                placeholder: 'W czym możemy pomóc?',
            },

            submit: {
                label: 'Wyślij wiadomość',
                error: 'Wygląda na to, że niektóre dane wymagają poprawy. Sprawdź zaznaczone pola i spróbuj ponownie.',
                success:
                    'Dziękujemy! Twoja wiadomość została wysłana pomyślnie. Nasz zespół odpowie na Twój adres e-mail tak szybko, jak to możliwe.',
            },
        },
    },

    worker: {
        metaTitle: (name: string, role: string): string => `${name} – ${role}`,

        educations: 'Wykształcenie',
        experiences: 'Doświadczenie zawodowe',
        licences: 'Licencje i certyfikaty',

        linkedin: (name: string): string => `${name} na LinkedIn`,
    },

    partner: {
        other: 'Pozostali nasi partnerzy',
        seeAll: 'Zobacz więcej',
    },

    notFound: {
        title: 'Nie znaleźliśmy strony, której szukasz',
        description:
            'Wybrany adres mógł zostać zmieniony lub usunięty. Zamiast wracać do strony głównej, skorzystaj z naszej listy polecanych produktów finansowych. Porównaj oferty i wybierz tę, która najlepiej odpowiada Twoim potrzebom.',
    },

    formApp: {
        type: 'wniosker',
        pathname: '/wniosek/',

        config: {
            hash: {
                default: '7ee8b36f5abb76c1b137507620f84ef9',
                day: '877dd012ad5c26447d27b977c16fe88d',
                month: '79912b317fce727635c2c1249beb8a1f',
            },
        },

        param: {
            amount: 'amount',
            period: 'period',
            url: 'url',
        },

        copy: {
            metaTitle: 'Wniosek o finansowanie',
        },
    },
};
